import { useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';

const tableCustomStyles = {
  headCells: {
    style: {
      fontSize: '0.78rem',
      fontWeight: 700,
      textTransform: 'uppercase' as const,
      color: '#495057',
      backgroundColor: '#f8f9fa',
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  },
  cells: {
    style: {
      fontSize: '0.875rem',
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  },
  rows: {
    style: {
      minHeight: '48px',
      '&:hover': { backgroundColor: '#f5f8ff' },
    },
  },
};

const ProductionCycleColumns = (props) => {
  const productionCycleColumns = useMemo(
    () => [
      {
        name: props.t('production_cycle.label'),
        selector: (row) => row.label,
        sortable: true,
        center: true,
      },
      {
        name: props.t('production_cycle.project'),
        selector: (row) => row.projet,
        sortable: true,
        center: true,
      },
      {
        name: props.t('production_cycle.tpe'),
        selector: (row) => row.tpe,
        sortable: true,
        center: true,
      },
      {
        name: props.t('production_cycle.production'),
        selector: (row) => row.production,
        sortable: true,
        center: true,
      },
      {
        name: props.t('production_cycle.mode'),
        selector: (row) => row.mode,
        sortable: true,
        center: true,
      },
      {
        name: props.t('production_cycle.start_date'),
        selector: (row) => row.startDate,
        sortable: true,
        center: true,
      },
      {
        name: props.t('production_cycle.end_date'),
        selector: (row) => row.endDate,
        sortable: true,
        center: true,
      },
      {
        name: props.t('production_cycle.active'),
        selector: (row) => row.active,
        sortable: true,
        center: true,
      },
      {
        id: 'Action',
        name: props.t('actions'),
        selector: (row) => row.action,
        sortable: false,
        center: true,
      },
    ],
    [props.t]
  );

  return <DataTable columns={productionCycleColumns} data={props.data} customStyles={tableCustomStyles} />;
};

export default translate(ProductionCycleColumns);
